import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Marissa_Pet/subs.vtt';
import poster from '@/static/assets/reviews/Marissa_Pet/video.jpg';

export const Marissa: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Marissa',
  videoUrl: `${ASSETS_URL}/pet/Marissa_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
